import React from "react";
import "./Startup.css";
import "../../Controls/TextLabel.mjs";
import TextLabel from "../../Controls/TextLabel.mjs";
import {Button} from "reactstrap";
import LoadingPanel from "../Panels/LoadingPanel.mjs";
import SplashPanel from "./SplashPanel.mjs";
import Authentication from "./Authentication.mjs";

const G = window.glob;

const Startup = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			info: G.getStatus('AppInfo'),
			username: '',
			password: '',
			delay: 200,
		};
		const s = G.getStatus('Scenario');
		if (s?.id) {
			this.state.scenario = s.id;
			this.state.nomescenario = s.desc || s.name;
			this.state.players = G.getStatus('Players');
		}
		this.uid = G.generateUid('Startup');
		this.renderContent = this.renderContent.bind(this);
		this.header = this.header.bind(this);
		this.loadScenari = this.loadScenari.bind(this);
		this.loadScenario = this.loadScenario.bind(this);
		this.selectScenario = this.selectScenario.bind(this);
		this.authenticated = this.authenticated.bind(this);
	}

	componentDidMount() {
		G.register('AppInfo', (s) => {
			this.setState({info: s});
		}, this.uid);
		G.register('Scenario', (s) => {
			this.setState({scenario: s?.id, nomescenario: s?.desc || s?.name});
		}, this.uid);
		G.register('Players', (ps) => {
			this.setState({players: ps});
		}, this.uid);
	}

	componentWillUnmount() {
		G.deregister(this.uid);
	}

	loadScenari() {
		G.api(
			{entity: 'startup', operation: 'appinfo'},
			{appid: G.prop.appID}
		).then((r) => {
			G.setStatus('Scenario', undefined, true);
			G.setStatus('AppInfo', r, true);
		}).catch(e => {
			console.error(e);
		}).finally(() => {
			this.setState({loading: false});
		});
	}

	authenticated(r) {
		setTimeout(() => {
			const config = {};
			if (r?.config && typeof r.config === 'object') {
				Object.entries(r.config).forEach(([n, v]) => {
					if (typeof v === 'boolean') {
						config[n] = {enabled: v, disabled: !v};
					} else {
						config[n] = v;
					}
				})
			}
			G.setStatus('CopioneConfig', config, true);
			G.setStatus('Player', r?.player, true);
			G.setStatus('Copione', r?.copione, true);
			let tab = 'Dashboard'; //'Game';
			// if ( r?.player?.admin?.gameMaster ) tab = 'Game';
			// else if ( r?.player?.admin?.seeLog ) tab = 'Backstage';
			G.setCurrentPage({name: 'Game', params: {tab: tab}});
		}, this.state.delay);
	}

	loadScenario(s) {
		this.setState({loading: true});
		setTimeout(() => {
			G.api(
				{entity: "startup", operation: "listplayers"},
				{domain: this.state.info.domain, scenario: s.id}
			).then(r => {
				G.setStatus('Players', r?.players, true);
				G.setStatus('Groups', r?.groups, true);
				G.setStatus('Scenario', s, true );
			}).finally(() => {
				this.setState({
					scenario: s.id,
					nomescenario: s.name,
					loading: false,
					players: G.getStatus('Players'),
					username: ''
				});
			})
		}, this.state.delay);
	}

	selectScenario() {
		const ss = Array.isArray(this.state.info?.scenari) ? this.state.info.scenari : [];
		if (ss.length === 0) {
			return (
				<div className={"ChooseScenario"}>
					{this.header()}
					<h4 key={"chooser"}>
						<TextLabel value={"NoScenari"}/>
					</h4>
					<Button
						color={"danger"}
						className={"mt-2 cancel btn-icon center"}
						onClick={() => {
							G.logout(true);
						}}
					>
						<i><TextLabel value={"back"} lang={"icon"}/></i>
						<b><TextLabel value={"Cancel"}/></b>
					</Button>
					{
						this.state.info?.customMessage && (
							<div className={"customMessage"} key={"customMessage"}>
								{this.state.info.customMessage}
							</div>
						)
					}
				</div>
			);
		}
		return (
			<div className={"ChooseScenario"}>
				{this.header()}
				<h4 key={"chooser"}>
					<TextLabel value={"ChooseScenario"}/>
				</h4>
				<ul key={"list"}>
					{
						ss.map(s => {
							return (
								<li key={s.id}>
									<Button
										color={ s.real ? "warning" : "success"}
										title={s.desc || ""}
										className={"btn-icon center"}
										onClick={() => {
											this.loadScenario(s);
										}}
									>
										<b>
											{s.name}
										</b>
										<i>
											{ s.real ? '☢️' : <TextLabel value={"forward"} lang={"icon"}/> }
										︎</i>
									</Button>
								</li>
							)
						})
					}
				</ul>
				<Button
					color={"danger"}
					className={"mt-2 cancel btn-icon center"}
					onClick={() => {
						G.logout(true);
					}}
				>
					<i><TextLabel value={"back"} lang={"icon"}/></i>
					<b><TextLabel value={"Cancel"}/></b>
				</Button>
				{
					this.state.info?.customMessage && (
						<div className={"customMessage"} key={"customMessage"}>
							{this.state.info.customMessage}
						</div>
					)
				}
			</div>
		);
	}

	header() {
		const out = [];
		const dom = this.state.info?.desc;
		const scen = this.state.nomescenario;
		if (dom && scen) {
			out.push(<h4 key={"dom"}><TextLabel value={"lock"} lang={"icon"}/> {dom}</h4>);
			out.push(<h3 key={"scen"}>{scen}</h3>);
		} else if (dom || scen) {
			out.push(<h3 key={"domorscen"}>{dom || scen}</h3>);
		}
		return out;
	}

	renderContent(info, loading) {
		if (loading) return <LoadingPanel/>;
		if (!info) return (
			<SplashPanel onChange={() => {
				this.setState({loading: true});
				setTimeout(() => {
					this.loadScenari()
				}, this.state.delay);
			}}/>
		);
		if (!this.state.scenario) return this.selectScenario();
		if (!(this.state.auth || G.getStatus('Player'))) return (
			<Authentication
				header={this.header()}
				onDone={r => {
					this.authenticated(r);
				}}
				onCancel={() => {
					this.setState({scenario: undefined, nomescenario: undefined})
				}}
			/>
		);
		setTimeout(() => {
			G.setCurrentPage({name: 'Game', params: G.getCurrentPageParams()})
		}, 1000);
		return <LoadingPanel/>;
	}

	render() {
		return (
			<div className={"Startup"} id={this.uid}>
				{this.renderContent(this.state.info, this.state.loading)}
			</div>
		);
	}
}

export default Startup;
